export default __webpack_public_path__ + "static/media/filmoscope.e1173a14.svg";